	<freud-select
		[placeholder]="placeholder ?? 'APPOINTMENTS.CONTACT' | translate"
		[options]="patients"
		[label]="'GENERAL.PATIENT' | translate"
		[filter]="true"
		(onFilter)="onFilter($event)"
		optionValue="value"
		[invalid]="invalid"
		[disabled]="disabled"
		[(ngModel)]="value"
	></freud-select>
	